import { defaultPaddingLeft } from '../../../../../constants/sizes';

export default {
  container: {
    height: '100%',
    width: '100%'
  },
  content: {
    width: '100%',
    padding: `10px ${defaultPaddingLeft}px`,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  element: {
    width: '40%',
    flexShrink: 0,
    margin: '20px 0px'
  },
  slider: {
    margin: '40px 0px',
    width: '70%'
  }
};
